// precoArte.js — A CONTA ÚNICA do preço de personalização da F77 (Sergio, 18/10/2026).
// Este arquivo é copiado IGUAL (byte a byte) para: backend lib/precificacao/precoArte.js, ERP src/lib/precoArte.js
// e tema do site assets/f77-preco-arte.js. Mudou aqui, muda nos três (o teste de cada repo confere o hash).
// Sem dependências. Funciona em Node (require) e no navegador (window.PrecoArte).
//
// Regra:
//   preço da arte por peça = custo real da arte × markup da faixa, arredondado para terminar em ,90
//   faixa = quantidade de PEÇAS que recebem aquela arte (não o número de estampas do pedido)
//   faixas: 1–9 · 10–29 · 30–49 · 50+   (o custo do bordado cai pela metade de 50+: custo_50)
//   piso: nunca abaixo de MARKUP_MINIMO (2×) o custo real da faixa
//   2ª arte igual na mesma peça (2º peito, 2ª manga): usa mk_segunda se a arte tiver; senão o mesmo mk
//   preco_fixo[i] (opcional) substitui o preço calculado naquela faixa (ex.: manga 30–49 = 5,50)
//   ACRÉSCIMO POR PEÇA PERSONALIZADA (18/10 noite): quem leva poucas peças paga um valor fixo POR PEÇA, uma vez só (não
//   importa quantas estampas): 1 peça +17 · 2 +8 · 3–4 +4 · 5+ zero (Sergio 18/10 noite: tirou o de 5–9). Conta = total de peças personalizadas do pedido.
//   ESTAMPA EXTRA (proposta B, Sergio 18/10 noite): a estampa principal usa a escada cheia; toda estampa a mais na peça (costas quando
//   há frente, manga, 2º peito) usa no máximo MK_EXTRA (3 · 2,5 · 2,25 · 2) — o markup final da peça não sobe quando entra estampa.
// Silk NÃO passa por aqui (continua na fórmula própria: serviço × multiplicador + quadro rateado).
(function (root) {
  'use strict';

  const VERSAO = '2026-10-18.3';
  const MARKUP_MINIMO = 2;
  const MK_EXTRA = [3, 2.5, 2.25, 2];
  const FAIXAS = [
    { min: 1, max: 9, rotulo: '1 a 9' },
    { min: 10, max: 29, rotulo: '10 a 29' },
    { min: 30, max: 49, rotulo: '30 a 49' },
    { min: 50, max: Infinity, rotulo: '50+' },
  ];

  const r2 = (n) => Math.round(n * 100) / 100;

  function indiceFaixa(pecas) {
    const q = Math.max(1, Math.floor(Number(pecas) || 0));
    for (let i = FAIXAS.length - 1; i >= 0; i--) if (q >= FAIXAS[i].min) return i;
    return 0;
  }

  // Termina em ,90 (o ,90 mais perto); se ficar abaixo do piso, sobe R$ 1.
  function arredonda90(valor, piso) {
    let x = Math.round(valor + 0.10) - 0.10;
    if (x < piso - 1e-9) x += 1;
    return r2(x);
  }

  // arte: { tecnica, tamanho, custo (até 49), custo_50 (50+, opcional = custo),
  //         mk: [m1,m2,m3,m4], mk_segunda?: [..4], preco_fixo?: [..4 ou null] }
  // opcoes.segunda: mesma arte repetida (2º peito) → mk_segunda. opcoes.extra: estampa a mais na peça → teto MK_EXTRA.
  function precoArte(arte, pecas, opcoes) {
    if (!arte || !Array.isArray(arte.mk) || arte.mk.length !== 4) throw new Error('arte sem markup por faixa');
    const segunda = !!(opcoes && opcoes.segunda);
    const extra = !!(opcoes && opcoes.extra);
    const i = indiceFaixa(pecas);
    const custo = i === 3 && arte.custo_50 != null ? Number(arte.custo_50) : Number(arte.custo);
    if (!(custo > 0)) throw new Error(`custo inválido para ${arte.tecnica} ${arte.tamanho}`);
    const escada = segunda && Array.isArray(arte.mk_segunda) ? arte.mk_segunda : arte.mk;
    const mkFaixa = Number(escada[i]) || 0;
    const markup = Math.max(extra ? Math.min(mkFaixa, MK_EXTRA[i]) : mkFaixa, MARKUP_MINIMO);
    const piso = r2(custo * MARKUP_MINIMO);
    const fixo = !segunda && !(extra && mkFaixa > MK_EXTRA[i]) && Array.isArray(arte.preco_fixo) ? arte.preco_fixo[i] : null;
    const preco = fixo != null && fixo !== '' ? Math.max(r2(Number(fixo)), piso) : arredonda90(custo * markup, piso);
    return { preco, custo: r2(custo), markup, markup_real: r2(preco / custo), faixa: FAIXAS[i].rotulo, faixa_indice: i, segunda, extra, versao: VERSAO };
  }

  // Acréscimo por peça personalizada. pecas = total de peças personalizadas do pedido. tabela = [1, 2, 3–4, 5–9] (padrão abaixo).
  const ACRESCIMO_PADRAO = [17, 8, 4, 0];
  function acrescimoPeca(pecas, tabela) {
    const q = Math.max(0, Math.floor(Number(pecas) || 0));
    if (q === 0 || q >= 10) return 0;
    const t = Array.isArray(tabela) && tabela.length === 4 ? tabela : ACRESCIMO_PADRAO;
    const i = q >= 5 ? 3 : q >= 3 ? 2 : q >= 2 ? 1 : 0;
    return r2(Math.max(0, Number(t[i]) || 0));
  }

  // Várias artes na mesma peça. itens: [{ arte, segunda?, extra? }]. Soma o preço de cada uma.
  function precoArtes(itens, pecas) {
    const linhas = (itens || []).map((it) => ({ ...precoArte(it.arte, pecas, { segunda: it.segunda, extra: it.extra }), tecnica: it.arte.tecnica, tamanho: it.arte.tamanho }));
    return { total: r2(linhas.reduce((s, l) => s + l.preco, 0)), custo: r2(linhas.reduce((s, l) => s + l.custo, 0)), linhas, versao: VERSAO };
  }

  // Tabela inteira (para a tela de Premissas, o site e a conferência): preço de cada arte nas 4 faixas.
  function tabela(artes) {
    return (artes || []).map((a) => ({
      tecnica: a.tecnica, tamanho: a.tamanho, custo: a.custo, custo_50: a.custo_50 != null ? a.custo_50 : a.custo,
      faixas: FAIXAS.map((f) => precoArte(a, f.min)),
      segunda: Array.isArray(a.mk_segunda) ? FAIXAS.map((f) => precoArte(a, f.min, { segunda: true })) : null,
      extra: FAIXAS.map((f) => precoArte(a, f.min, { extra: true })),
    }));
  }

  const api = { VERSAO, MARKUP_MINIMO, MK_EXTRA, FAIXAS, ACRESCIMO_PADRAO, indiceFaixa, arredonda90, precoArte, precoArtes, acrescimoPeca, tabela };
  if (typeof module !== 'undefined' && module.exports) module.exports = api; else root.PrecoArte = api;
})(typeof window !== 'undefined' ? window : globalThis);
